import { LESSON_TYPES } from '../data/lessonTypes';

const hasContestLesson = (lessons) => {
  const hasLiveLecture = lessons.some(
    (lesson) => lesson.lesson_type === LESSON_TYPES.liveLecture
  );
  const hasContest = lessons.some(
    (lesson) => lesson.lesson_type === LESSON_TYPES.contest
  );

  if (hasLiveLecture && hasContest) {
    return false;
  }

  return hasContest;
};

export default hasContestLesson;
